// extracted by mini-css-extract-plugin
export var buttonContainer = "_6g-1";
export var fontSizeSelect = "_6g-3";
export var formatSelect = "_6g-2";
export var formats = "_6g-4";
export var hidden = "_6g-5";
export var icon = "_6g-6";
export var select = "_6g-0";